const parseActivityLogData = (data: string | Record<string, unknown>) => {
  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch {
      return {};
    }
  }

  return data;
};

export default parseActivityLogData;
